import ScriptCenter from "./script-center";
interface SaleSmartlyUserInfo {
  user_id: number | string;
  user_name?: string;
  phone?: string;
  email?: string;
}

export class SaleSmartly {
  ssq: any;
  isFoxrenderfarm: boolean;
  constructor() {
    this.isFoxrenderfarm = location.host.indexOf("foxrenderfarm.com") !== -1;
    this.init();
  }
  async init() {
    if (!this.isFoxrenderfarm) return;
    this.ssq = await ScriptCenter.load(ScriptCenter.menu.SaleSmartly);
    (window as any).__ssc.setting = { hideIcon: true }; //true为隐藏，false为不隐藏
  }

  async setUserInfo(userInfo: SaleSmartlyUserInfo) {
    if (!this.isFoxrenderfarm) return;
    if (!this.ssq) await this.init();
    this.ssq.push("setLoginInfo", userInfo);
  }
  async onUnRead(callback: (num: number) => void) {
    if (!this.isFoxrenderfarm) return;
    if (!this.ssq) await this.init();
    this.ssq.push("onUnRead", (obj: { num: number }) => {
      callback(obj.num);
    });
  }

  clearUserInfo() {
    if (!this.isFoxrenderfarm) return;
    this.ssq.push("clearUser");
  }

  async openChatWindow() {
    if (!this.isFoxrenderfarm) return;
    if (!this.ssq) await this.init();
    this.ssq.push("chatOpen");
  }
}

export const saleSmartlyInstance = new SaleSmartly();
